<script setup lang="ts"></script>

<template>
  <icon name="lucide:file-edit" />
</template>

<style scoped></style>
